// extracted by mini-css-extract-plugin
export default {"cards":"CryptoCards_cards__njbX2","card":"CryptoCards_card__7joGX","title":"CryptoCards_title__XR-3g","loading":"CryptoCards_loading__erOUw"};